import React, { useState, useEffect } from "react";
import { CheckCircle, AlertTriangle, EyeOff, Eye, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import logo from "../../../assets/LOGO SEM FUNDO.PNG";

export default function LoginNovo() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [modoRecuperacao, setModoRecuperacao] = useState(false);
  const [mensagemRecuperacao, setMensagemRecuperacao] = useState("");
  const [erroRecuperacao, setErroRecuperacao] = useState("");

  const { login, erroLogin, limparErroLogin, recuperarSenha } = useAuth();

  // Limpa o erro quando o componente monta ou quando o usuário começa a digitar
  useEffect(() => {
    return () => limparErroLogin();
  }, []);

  const handleRecuperarSenha = async () => {
    if (!email) {
      setErroRecuperacao("Digite seu email acima para recuperar a senha.");
      return;
    }
    setErroRecuperacao("");
    setMensagemRecuperacao("");
    setCarregando(true);
    try {
      const resultado = await recuperarSenha(email);
      if (resultado.success) {
        setMensagemRecuperacao(resultado.message);
      } else {
        setErroRecuperacao(resultado.message);
      }
    } catch (error) {
      setErroRecuperacao("Erro ao enviar email de recuperação.");
    } finally {
      setCarregando(false);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    limparErroLogin();
    setSucesso(false);
    setCarregando(true);
    try {
      const resultado = await login(email, senha);
      console.log("📋 Resultado do login:", resultado);
      if (resultado.success) {
        setSucesso(true);
      }
      // O erro já é setado no AuthContext
    } catch (error) {
      console.log("❌ Catch error:", error);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "rgba(30, 64, 175, 0.95)",
          backdropFilter: "blur(10px)",
          borderRadius: "24px",
          padding: "48px",
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        {/* LOGO */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "120px",
              height: "120px",
              objectFit: "contain",
              borderRadius: "50%",
              background: "white",
              padding: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          />
          <h1
            style={{
              fontSize: "28px",
              fontWeight: "bold",
              color: "white",
              marginBottom: "8px",
            }}
          >
            HEPATO TX RONDÔNIA
          </h1>
          <p
            style={{
              fontSize: "14px",
              color: "#dbeafe",
            }}
          >
            Sistema Profissional LGPD + IA
          </p>
        </div>

        {/* MENSAGEM DE SUCESSO */}
        {sucesso && (
          <div
            style={{
              background: "#d1fae5",
              border: "2px solid #10b981",
              color: "#064e3b",
              padding: "12px 16px",
              borderRadius: "12px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            <CheckCircle size={20} color="#16a34a" />
            <span>Login realizado com sucesso!</span>
          </div>
        )}

        {/* MENSAGEM DE ERRO */}
        {erroLogin && (
          <div
            style={{
              background: "#fee2e2",
              border: "2px solid #ef4444",
              color: "#7f1d1d",
              padding: "12px 16px",
              borderRadius: "12px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            <AlertTriangle size={20} color="#ef4444" />
            <span>{erroLogin}</span>
          </div>
        )}

        {/* FORMULÁRIO */}
        <form onSubmit={handleSubmit}>
          {/* EMAIL - MUDOU DE "USUÁRIO" */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "white",
                marginBottom: "8px",
              }}
            >
              Email
            </label>
            <input
              type="email" // ← MUDOU: type="email"
              value={email} // ← MUDOU: value={email}
              onChange={(e) => setEmail(e.target.value)} // ← MUDOU
              placeholder="seu@email.com" // ← MUDOU
              required
              disabled={carregando} // ← NOVO: desabilita durante loading
              style={{
                width: "100%",
                padding: "14px 16px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                borderRadius: "12px",
                fontSize: "15px",
                outline: "none",
                transition: "all 0.3s",
                background: "rgba(255, 255, 255, 0.95)",
                boxSizing: "border-box",
                opacity: carregando ? 0.6 : 1, // ← NOVO
              }}
            />
          </div>

          {/* SENHA */}
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "white",
                marginBottom: "8px",
              }}
            >
              Senha
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={mostrarSenha ? "text" : "password"}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="Digite sua senha"
                required
                disabled={carregando}
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  paddingRight: "50px",
                  border: "2px solid rgba(255, 255, 255, 0.3)",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "all 0.3s",
                  background: "rgba(255, 255, 255, 0.95)",
                  boxSizing: "border-box",
                  opacity: carregando ? 0.6 : 1,
                }}
              />
              <button
                type="button"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  padding: "4px",
                  opacity: 0.6,
                  transition: "opacity 0.2s",
                }}
                onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
                onMouseOut={(e) => (e.currentTarget.style.opacity = "0.6")}
                title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
              >
                {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {/* ESQUECI MINHA SENHA */}
          <div style={{ textAlign: "right", marginBottom: "16px" }}>
            <button
              type="button"
              onClick={() => {
                if (modoRecuperacao) {
                  handleRecuperarSenha();
                } else {
                  setModoRecuperacao(true);
                  setMensagemRecuperacao("");
                  setErroRecuperacao("");
                }
              }}
              disabled={carregando}
              style={{
                background: "transparent",
                border: "none",
                color: modoRecuperacao ? "#fbbf24" : "#93c5fd",
                fontSize: "13px",
                cursor: "pointer",
                textDecoration: "underline",
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                padding: 0,
              }}
            >
              {modoRecuperacao ? (
                <>
                  <Mail size={14} style={{ marginRight: "6px" }} /> Enviar link
                  de recuperação
                </>
              ) : (
                "Esqueci minha senha"
              )}
            </button>
            {modoRecuperacao && (
              <button
                type="button"
                onClick={() => {
                  setModoRecuperacao(false);
                  setMensagemRecuperacao("");
                  setErroRecuperacao("");
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#93c5fd",
                  fontSize: "13px",
                  cursor: "pointer",
                  marginLeft: "12px",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  padding: 0,
                }}
              >
                Cancelar
              </button>
            )}
          </div>

          {/* MENSAGEM DE RECUPERAÇÃO - SUCESSO */}
          {mensagemRecuperacao && (
            <div
              style={{
                background: "#d1fae5",
                border: "2px solid #10b981",
                color: "#064e3b",
                padding: "12px 16px",
                borderRadius: "12px",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              <Mail size={20} />
              <span>{mensagemRecuperacao}</span>
            </div>
          )}

          {/* MENSAGEM DE RECUPERAÇÃO - ERRO */}
          {erroRecuperacao && (
            <div
              style={{
                background: "#fee2e2",
                border: "2px solid #ef4444",
                color: "#7f1d1d",
                padding: "12px 16px",
                borderRadius: "12px",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              <AlertTriangle size={20} color="#ef4444" />
              <span>{erroRecuperacao}</span>
            </div>
          )}

          {/* BOTÃO ENTRAR */}
          <button
            type="submit"
            disabled={carregando} // ← NOVO: desabilita durante loading
            style={{
              width: "100%",
              padding: "14px",
              background: carregando ? "#94a3b8" : "white", // ← NOVO: cor diferente quando loading
              color: "#1e40af",
              border: "none",
              borderRadius: "12px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: carregando ? "not-allowed" : "pointer", // ← NOVO
              transition: "all 0.3s",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            }}
          >
            {carregando ? "Entrando..." : "Entrar"}{" "}
            {/* ← NOVO: texto dinâmico */}
          </button>
        </form>

        {/* RODAPÉ */}
        <div
          style={{
            marginTop: "24px",
            paddingTop: "24px",
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "12px",
              color: "#dbeafe",
              margin: 0,
            }}
          >
            Sistema em conformidade com a LGPD
          </p>
          {/* B240 (AI_108): acesso público à página de Transparência/Privacidade */}
          <button
            type="button"
            onClick={() => (window.location.href = "/transparencia")}
            style={{
              marginTop: "10px",
              background: "none",
              border: "none",
              color: "white",
              fontSize: "13px",
              fontWeight: 600,
              textDecoration: "underline",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Transparência e Privacidade
          </button>
        </div>
      </div>
    </div>
  );
}
